import React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

const StatusTabs = ({
  history,
  location: { search },
  statuses,
  activeStatus,
  setActiveStatus,
  activeAssociates,
  setAssocCheckedItems,
  activeSite
}) => {
  const params = qs.parse(search);
  const enabledStatuses = activeSite.enable_preferred_schedule ? statuses : statuses.filter((x) => x != 'Preferred')

  const handleChangeStatus = (status) => {
    setActiveStatus(status);
    setAssocCheckedItems([]);

    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        status,
      }),
    });
  };

  return (
    <div
      className="pt-3 d-flex justify-content-start"
      style={{
        minWidth: 0,
        maxWidth: '94.6vw',
        overflowX: 'auto',
      }}
    >
      {enabledStatuses.map((status) => (
        <div
          key={status}
          className="flex-shrink-0"
          onClick={() => handleChangeStatus(status)}
        >
          <div
            className={status === activeStatus ? 'adjust-card-shadow' : ''}
            style={
              status === activeStatus
                ? {
                    cursor: 'pointer',
                    marginRight: '1.5rem',
                    backgroundColor: '#5156BE',
                    padding: 10,
                    paddingLeft: 15,
                    paddingRight: 15,
                    borderRadius: 4,
                    marginBottom: 10,
                  }
                : {
                    cursor: 'pointer',
                    marginRight: '1.5rem',
                    paddingTop: 10,
                  }
            }
          >
            <span
              className={`${
                status === activeStatus ? 'text-white' : 'text-muted'
              } fw-medium adjust-status`}
            >
              {status}{' '}
              <span className="adjust-associate-count fw-normal text-white">
                {activeAssociates.assigned && status === 'Assigned'
                  ? activeAssociates.assigned.length
                  : activeAssociates.notAssigned && status === 'Not Assigned'
                  ? activeAssociates.notAssigned.length
                  : activeAssociates.acknowledged && status === 'Ack'
                  ? activeAssociates.acknowledged.length
                  : activeAssociates.notAcknowledged && status === 'Not Ack'
                  ? activeAssociates.notAcknowledged.length
                  : activeAssociates.onTime && status === 'On Time'
                  ? activeAssociates.onTime.length
                  : activeAssociates.late && status === 'Late'
                  ? activeAssociates.late.length
                  : activeAssociates.absent && status === 'Absent'
                  ? activeAssociates.absent.length
                  : activeAssociates.cancelled && status === 'Cancelled'
                  ? activeAssociates.cancelled.length
                  : activeAssociates.preferred && status === 'Preferred'
                  ? activeAssociates.preferred.length
                  : activeAssociates.notAvailable && status === 'Not Available'
                  ? activeAssociates.notAvailable.length
                  : 0}
              </span>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default withRouter(StatusTabs);
